const getResponseBody = response => {
  return response.clone().blob();
};

const checkStatus = ({ response, body, fileName }) => {
  if (response.ok) {
    return { response, body, fileName };
  } else {
    throw new ResponseError(response.status, response, body);
  }
};

const fetchFile = (url, options = {}) => {
  const contentTypeHeader = { headers: { 'Content-Type': 'application/json' } };
  return fetch(url, { ...contentTypeHeader, ...options })
    .then(response => {
      let fileName = 'Export to Excel.xlsx';
      const contentDisposition = response.headers.get('Content-Disposition');

      if (contentDisposition) {
        const splittedContentDisposition = contentDisposition.split('filename=');
        if (splittedContentDisposition.length > 1) {
          fileName = splittedContentDisposition[1];
        }
      }
      return getResponseBody(response).then(body => ({
        response,
        body,
        fileName,
      }));
    })
    .then(checkStatus);
};

function ResponseError(status, response, body) {
  this.name = 'ResponseError';
  this.status = status;
  this.response = response;
  this.body = body;
}

ResponseError.prototype = Error.prototype;

export default fetchFile;
